import { render, staticRenderFns } from "./testResult.vue?vue&type=template&id=4a1d42ba&scoped=true"
import script from "./testResult.vue?vue&type=script&lang=js"
export * from "./testResult.vue?vue&type=script&lang=js"
import style0 from "./testResult.vue?vue&type=style&index=0&id=4a1d42ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d42ba",
  null
  
)

export default component.exports